export default "__VITE_ASSET__BU4x9eeP__"